import styled, { css } from "styled-components";

interface IWithState {
  state: "available" | "occupied" | "maintenance" | "reserved";
  isReserved: boolean;
}

export const Container = styled.div``;
export const StateContainer = styled.div`
  margin-bottom: 0.5rem;
`;
export const Price = styled.p`
  color: var(--primary-color);
  margin: 0.5rem 0;
`;
export const Flag = styled.img`
  position: absolute;
  top: 0;
  left: 1rem;
`;
export const State = styled.p<IWithState>`
  color: var(--maintenance-hu);
  ${({ state, isReserved }) =>
    state !== "reserved" &&
    isReserved &&
    css`
      ::after {
        content: "/reservado";
        color: var(--reserved-hu);
      }
    `}
`;
